import { useTranslation } from "react-i18next";
import { LANDING_CONTENT } from "../content";
import { BeforeAfter } from "./BeforeAfter";
import { PhotoBrief } from "./PhotoSlot";
import { Reveal } from "./Reveal";
import { Section, SectionHeading, SectionLead } from "./Section";

// Section A — the proof it's real. Answers the single biggest doubt head-on
// ("will it really look like them?") with a before→after the visitor controls:
// the photo they'd send vs. the pillow cut to that pet's outline.
export function ProofIsReal() {
  const { t } = useTranslation("landing");
  const { before, after } = LANDING_CONTENT.proof;
  return (
    <Section id="proof" labelledBy="proof-heading" className="bg-paper pt-[clamp(2rem,4vw,3.5rem)]">
      <Reveal>
        <div className="mx-auto max-w-2xl text-center">
          <SectionHeading id="proof-heading">{t("proof.heading")}</SectionHeading>
          <SectionLead className="mt-4">{t("proof.lead")}</SectionLead>
        </div>
      </Reveal>
      <Reveal delayMs={80} className="mx-auto mt-10 max-w-md">
        <BeforeAfter
          before={{
            src: before.src,
            alt: t("proof.beforeAlt"),
            width: before.width,
            height: before.height,
          }}
          after={{
            src: after.src,
            alt: t("proof.afterAlt"),
            width: after.width,
            height: after.height,
          }}
          beforeLabel={t("proof.beforeCaption")}
          afterLabel={t("proof.afterCaption")}
          sliderLabel={t("proof.sliderLabel")}
          afterPlaceholder={after.placeholder}
        />
        <p className="mt-3 text-center text-sm text-muted-foreground">{t("proof.sampleNote")}</p>
        <PhotoBrief briefId="proofAfter" className="mt-4" />
      </Reveal>
    </Section>
  );
}
